import { css, Global } from '@emotion/react'
import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import type { PropsWithChildren } from 'react'

import { Footer } from '@cash-web/support/feature-main'
import { Header } from '@cash-web/support/ui-components'

import Link from './src/components/RegionalisedLink'
import useContactHref from './src/hooks/useContactHref'

const GlobalContainer = styled.div`
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-flow: column;
`

const BodyContainer = styled.div`
  background-color: ${props => props.theme.colors.behindBackground};
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
`

const Layout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation()
  const contactHref = useContactHref()

  const ariaLabel = t('Cash App support', { context: 'Link to Help Center home from nav' })

  return (
    <GlobalContainer>
      <Global
        styles={css`
          a {
            &:focus,
            &:focus-visible {
              outline: none;
            }
          }
        `}
      />
      <Header Link={Link} linkProps={{ href: '/', 'aria-label': ariaLabel }} t={t} />
      <BodyContainer>{children}</BodyContainer>
      <Footer Link={Link} linkProps={{ href: '/', 'aria-label': ariaLabel }} t={t} contactHref={contactHref} />
    </GlobalContainer>
  )
}

export default Layout
